import { Eye, Users, MousePointerClick, Percent } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

const CARDS = [
  { key: 'views', label: 'Aperturas', icon: Eye, color: '#264639' },
  { key: 'unique_visitors', label: 'Visitantes únicos', icon: Users, color: '#0D1D2A' },
  { key: 'clicks', label: 'Clics en botones', icon: MousePointerClick, color: '#C36F4D' },
  { key: 'ctr', label: 'Clics por apertura', icon: Percent, color: '#E7B72D', suffix: '%' },
];

export function QrStatCards({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="qr-stat-cards">
      {CARDS.map(({ key, label, icon: Icon, color, suffix }) => (
        <div key={key} className="bg-white rounded-xl border border-[#E7E5E4] p-4" data-testid={`qr-stat-${key}`}>
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs uppercase tracking-wider text-[#78716C]">{label}</p>
            <span className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}1A`, color }}>
              <Icon className="w-4 h-4" />
            </span>
          </div>
          <p className="text-3xl font-bold text-[#1C1917]" style={{ fontFamily: 'Outfit' }}>
            {stats ? stats[key] : '—'}{stats && suffix ? suffix : ''}
          </p>
        </div>
      ))}
    </div>
  );
}

export function QrClicksList({ stats }) {
  const items = stats?.clicks_by_link || [];
  const max = Math.max(1, ...items.map((i) => i.count));
  return (
    <div className="bg-white rounded-xl border border-[#E7E5E4] p-5" data-testid="qr-clicks-list">
      <h2 className="text-base font-semibold text-[#1C1917] mb-1" style={{ fontFamily: 'Outfit' }}>Botón más pulsado</h2>
      <p className="text-xs text-[#78716C] mb-4">
        {stats?.top_link ? <>{stats.top_link.label} · {stats.top_link.count} clics</> : 'Todavía no hay clics en este período'}
      </p>
      <ul className="space-y-3">
        {items.map((item, i) => (
          <li key={item.link_id} data-testid={`qr-click-row-${item.link_id}`}>
            <div className="flex justify-between text-sm mb-1">
              <span className="text-[#1C1917] font-medium">{item.label}{item.link_id === 'share' && <span className="text-[#A8A29E] font-normal"> · veces compartida</span>}</span>
              <span className="text-[#57534E]">{item.count}</span>
            </div>
            <div className="h-2 rounded-full bg-[#F5F4F0] overflow-hidden">
              <div className="h-full rounded-full transition-[width] duration-500" style={{ width: `${(item.count / max) * 100}%`, backgroundColor: i === 0 ? '#264639' : '#E7B72D' }} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function QrDailyChart({ stats }) {
  const data = (stats?.daily || []).map((d) => ({ ...d, label: d.date.slice(5).replace('-', '/') }));
  return (
    <div className="bg-white rounded-xl border border-[#E7E5E4] p-5 lg:col-span-2" data-testid="qr-daily-chart">
      <h2 className="text-base font-semibold text-[#1C1917] mb-4" style={{ fontFamily: 'Outfit' }}>Aperturas y clics por día</h2>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} barGap={2}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E7E5E4" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#78716C' }} interval="preserveStartEnd" />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#78716C' }} width={28} />
            <Tooltip cursor={{ fill: '#F5F4F0' }} contentStyle={{ borderRadius: 8, border: '1px solid #E7E5E4', fontSize: 12 }} />
            <Bar dataKey="views" name="Aperturas" fill="#264639" radius={[4, 4, 0, 0]} />
            <Bar dataKey="clicks" name="Clics" fill="#E7B72D" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
